/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable prefer-template */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/function-component-definition */
/* eslint-disable react/prop-types */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import {
   LineChart,
   Line,
   XAxis,
   YAxis,
   CartesianGrid,
   Tooltip,
   Legend,
   ResponsiveContainer,
} from 'recharts';

import Loading from '../../components/Loading';
import axios from '../../services/axios';

import { Container } from '../../styles/layout/Container';
import {
   PageHeader,
   PageHeaderText,
   PageSubtitle,
   PageTitle,
} from '../../styles/layout/PageHeader';
import {
   Section,
   SectionBody,
   SectionHeader,
   SectionTitle,
} from '../../styles/layout/Section';
import { FormGrid } from '../../styles/layout/FormGrid';
import { Field } from '../../styles/forms/Field';
import { ActionBar, ActionBarRight } from '../../styles/layout/ActionBar';
import { EmptyState } from '../../styles/feedback/EmptyState';
import ProductNameSearch from '../../components/ProductNameSearch';
import { ChartContainer } from '../../styles/charts/ChartContainer';
import {
   chartColors,
   chartTheme,
   tooltipStyle,
   axisStyle,
} from '../../styles/charts/ChartStyles';

export default function StockEvolution() {
   const [pdvs, setPdvs] = useState([]);
   const [isLoading, setIsLoading] = useState(false);

   // Datas padrão: últimos 30 dias
   const today = new Date();
   const thirtyDaysAgo = new Date(today);
   thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);

   const formatDate = (date) =>
      date
         .toLocaleDateString('pt-BR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
         })
         .split('/')
         .reverse()
         .join('-');

   // Filtros
   const [startDate, setStartDate] = useState(formatDate(thirtyDaysAgo));
   const [endDate, setEndDate] = useState(formatDate(today));
   const [pdvId, setPdvId] = useState('');
   const [productQuery, setProductQuery] = useState('');
   const [selectedProduct, setSelectedProduct] = useState(null);

   // Resultado
   const [chartData, setChartData] = useState(null);

   useEffect(() => {
      async function loadPdvs() {
         try {
            setIsLoading(true);
            const response = await axios.get('/pdvs');
            const raw = response?.data ?? [];
            const list = Array.isArray(raw) ? raw : raw?.pdvs ?? [];
            setPdvs(Array.isArray(list) ? list : []);
         } catch (err) {
            const msg =
               err?.response?.data?.errors?.[0] ?? 'Erro ao carregar PDVs.';
            toast.error(msg);
         } finally {
            setIsLoading(false);
         }
      }

      loadPdvs();
   }, []);

   const handleClearFilters = () => {
      const ok = window.confirm('Deseja limpar todos os filtros?');
      if (!ok) return;

      setStartDate(formatDate(thirtyDaysAgo));
      setEndDate(formatDate(today));
      setPdvId('');
      setProductQuery('');
      setSelectedProduct(null);
      setChartData(null);
   };

   const handleSearch = async (e) => {
      e.preventDefault();

      // Validações
      if (!startDate || !endDate) {
         toast.error('Informe o período');
         return;
      }

      if (startDate > endDate) {
         toast.error('A data inicial não pode ser maior que a data final');
         return;
      }

      if (!pdvId) {
         toast.error('Selecione um PDV');
         return;
      }

      // Produto (SKU ou autocomplete)
      const pq = (productQuery || '').trim();
      const isDigits = /^\d+$/.test(pq);

      let prodId = null;

      if (selectedProduct?.id) {
         prodId = selectedProduct.id;
      } else if (isDigits && pq.length === 7) {
         // SKU completo - buscar produto
         try {
            const prodRes = await axios.get(`/products/sku/${pq}`);
            prodId = prodRes?.data?.id;
         } catch {
            toast.error('Produto não encontrado com este SKU');
            return;
         }
      } else {
         toast.error(
            'Selecione um produto ou digite o SKU completo (7 dígitos)'
         );
         return;
      }

      setIsLoading(true);

      try {
         const response = await axios.get(
            `/stock/history/${prodId}/${pdvId}`,
            {
               params: {
                  start_date: startDate,
                  end_date: endDate,
               },
            }
         );

         // eslint-disable-next-line prefer-destructuring
         const data = response.data;

         // Formata dados para o gráfico
         const formattedData = (data.history || []).map((item) => ({
            date: new Date(`${item.snapshot_date  }T00:00:00`).toLocaleDateString(
               'pt-BR',
               { day: '2-digit', month: '2-digit' }
            ),
            fullDate: item.snapshot_date,
            stock: item.stock_qtd,
            minStock: item.min_stock_qtd,
         }));

         setChartData({
            ...data,
            formattedData,
         });
      } catch (error) {
         const msg =
            error?.response?.data?.errors?.[0] ??
            'Erro ao buscar evolução do estoque.';
         toast.error(msg);
         setChartData(null);
      } finally {
         setIsLoading(false);
      }
   };

   const CustomTooltip = ({ active, payload }) => {
      if (active && payload && payload.length) {
         return (
            <div
               style={{
                  ...tooltipStyle.contentStyle,
               }}
            >
               <p style={{ ...tooltipStyle.labelStyle, marginBottom: '8px' }}>
                  {new Date(
                     payload[0].payload.fullDate + 'T00:00:00'
                  ).toLocaleDateString('pt-BR')}
               </p>
               {payload.map((entry, index) => (
                  <p
                     key={`item-${index}`}
                     style={{
                        color: entry.color,
                        fontSize: '13px',
                        margin: '4px 0',
                     }}
                  >
                     <strong>{entry.name}:</strong> {entry.value} un.
                  </p>
               ))}
            </div>
         );
      }
      return null;
   };

   return (
      <Container>
         <Loading isLoading={isLoading} />

         <PageHeader>
            <PageHeaderText>
               <PageTitle>Evolução do Estoque</PageTitle>
               <PageSubtitle>
                  Visualize a evolução do estoque de um produto ao longo do
                  tempo
               </PageSubtitle>
            </PageHeaderText>
         </PageHeader>

         <Section>
            <SectionHeader>
               <SectionTitle>Filtros</SectionTitle>
            </SectionHeader>

            <SectionBody>
               <form onSubmit={handleSearch}>
                  <FormGrid>
                     <Field $col={3} $colMobile={6}>
                        <label>Data Inicial *</label>
                        <input
                           type="date"
                           value={startDate}
                           onChange={(e) => setStartDate(e.target.value)}
                           max={formatDate(today)}
                           required
                        />
                     </Field>

                     <Field $col={3} $colMobile={6}>
                        <label>Data Final *</label>
                        <input
                           type="date"
                           value={endDate}
                           onChange={(e) => setEndDate(e.target.value)}
                           max={formatDate(today)}
                           required
                        />
                     </Field>

                     <Field $col={3} $colMobile={12}>
                        <label>PDV *</label>
                        <select
                           value={pdvId}
                           onChange={(e) => setPdvId(e.target.value)}
                           required
                        >
                           <option value="">Selecione...</option>
                           {pdvs.map((pdv) => (
                              <option key={String(pdv.id)} value={pdv.id}>
                                 {pdv.pdv_name ?? pdv.name ?? `${pdv.id}`}
                              </option>
                           ))}
                        </select>
                     </Field>

                     <Field $col={6} $colMobile={12}>
                        <label>Produto (SKU ou nome) *</label>
                        <ProductNameSearch
                           value={productQuery}
                           onChange={setProductQuery}
                           onSelect={setSelectedProduct}
                           nameLike={false}
                           displayMode="sku-name"
                           placeholder="Digite o SKU (7 dígitos) ou busque pelo nome..."
                           showHint
                        />
                     </Field>

                     <Field $col={12} $colMobile={12} $alignEnd>
                        <label>&nbsp;</label>
                        <ActionBar>
                           <ActionBarRight>
                              <button
                                 type="button"
                                 onClick={handleClearFilters}
                                 disabled={isLoading}
                              >
                                 Limpar
                              </button>
                              <button type="submit" disabled={isLoading}>
                                 Gerar Gráfico
                              </button>
                           </ActionBarRight>
                        </ActionBar>
                     </Field>
                  </FormGrid>
               </form>
            </SectionBody>
         </Section>

         {chartData && chartData.formattedData.length > 0 && (
            <ChartContainer>
               <h3>
                  {chartData.history[0]?.prod_name} •{' '}
                  {chartData.history[0]?.pdv_name}
               </h3>

               <div className="chart-wrapper">
                  <ResponsiveContainer width="100%" height="100%">
                     <LineChart
                        data={chartData.formattedData}
                        margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                     >
                        <CartesianGrid
                           strokeDasharray="3 3"
                           stroke={chartTheme.gridColor}
                           opacity={chartTheme.gridOpacity}
                        />
                        <XAxis
                           dataKey="date"
                           style={axisStyle}
                           tick={{ fontSize: 11 }}
                        />
                        <YAxis
                           style={axisStyle}
                           tick={{ fontSize: 11 }}
                           label={{
                              value: 'Quantidade',
                              angle: -90,
                              position: 'insideLeft',
                              style: axisStyle,
                           }}
                        />
                        <Tooltip content={<CustomTooltip />} />
                        <Legend
                           wrapperStyle={{
                              fontSize: chartTheme.legendFontSize,
                              paddingTop: '20px',
                           }}
                        />
                        <Line
                           type="monotone"
                           dataKey="stock"
                           stroke={chartColors.primary}
                           strokeWidth={2}
                           name="Estoque"
                           dot={{ r: 4 }}
                           activeDot={{ r: 6 }}
                        />
                        <Line
                           type="monotone"
                           dataKey="minStock"
                           stroke={chartColors.warning}
                           strokeWidth={2}
                           strokeDasharray="5 5"
                           name="Estoque Mínimo"
                           dot={false}
                        />
                     </LineChart>
                  </ResponsiveContainer>
               </div>

               <p
                  style={{
                     marginTop: '16px',
                     fontSize: '13px',
                     color: '#666',
                  }}
               >
                  📊 Total de {chartData.total_days} dias •{' '}
                  {chartData.start_date} até {chartData.end_date}
               </p>
            </ChartContainer>
         )}

         {!chartData && !isLoading && (
            <EmptyState
               title="Nenhum gráfico gerado"
               description="Preencha os filtros e clique em Gerar Gráfico."
            />
         )}

         {chartData && chartData.formattedData.length === 0 && (
            <EmptyState
               title="Sem dados para o período"
               description="Não há snapshots registrados para este produto/PDV no período selecionado."
            />
         )}
      </Container>
   );
}
